import { IEntity } from '../interfaces/entity';
import FileSystemItem from 'devextreme/file_management/file_system_item';

export interface IFileList {
  items: File[];
  totalCount: number;
}

class DevExFileItem extends FileSystemItem {
  parentPath?: string;
  dataItem: DevExDataItem;

  constructor(item: FileSystemItem) {
    super(item.path, item.isDirectory, item.pathKeys);
    this.dataItem = new DevExDataItem(item.dataItem);
  }
}

class DevExDataItem {
  id: string | number;
  uid: string;
  labels: string;
  summary: string;
  uploadedBy: string;
  lastModifiedDate: Date;
  uploadedDate: Date;
  casePrepExportStatus: string | number;

  constructor(item: DevExDataItem) {
    this.id = item.id;
    this.uid = item.uid;
    this.labels = item?.labels || '';
    this.summary = item?.summary || '';
    this.uploadedBy = item?.uploadedBy || '';
    this.lastModifiedDate = item?.lastModifiedDate;
    this.casePrepExportStatus =
      item?.casePrepExportStatus == typeof 'string'
        ? parseInt(item?.casePrepExportStatus)
        : item?.casePrepExportStatus || 0;
  }
}

export class File implements IEntity {
  id: number; // This will be unique and create by WebAPI when a file is saved
  uid: string; // This will be unique and create by WebAPI when a file is saved
  fileName: string;
  fileSize: number;
  path: string;
  lastModifiedDate: Date;
  labels: string;
  uri: string; // This will be unique and create by WebAPI when a file is saved
  attachmentType: number;
  summary: string = '';
  uploadedDate: Date;
  uploadedBy: string;
  details: string;
  locked: boolean;
  isDirectory: boolean;
  casePrepExportStatus: number;

  constructor(file: File | DevExFileItem, prefix?: string) {
    if (file instanceof FileSystemItem) {
      this.fileName = file.name;
      this.fileSize = file.size;
      this.lastModifiedDate = file.dataItem?.lastModifiedDate;
      this.uploadedDate = file.dataItem?.uploadedDate;
      this.details = '';
      this.locked = false;
      this.uid = file.dataItem?.uid;
      this.id = typeof file.dataItem?.id === 'string' ? parseInt(file.dataItem?.id) : file.dataItem?.id;
      this.labels = file.dataItem?.labels;
      this.uploadedBy = file.dataItem?.uploadedBy;
      this.uri = file.key;
      this.path = `${prefix}\\${file.parentPath?.replace('/', '\\')}`;
      this.attachmentType = 0;
      this.summary = file.dataItem?.summary;
      this.isDirectory = file.isDirectory;
      this.casePrepExportStatus =
        typeof file.dataItem?.casePrepExportStatus === 'string'
          ? file.dataItem?.casePrepExportStatus.length > 0
            ? parseInt(file.dataItem?.casePrepExportStatus)
            : 0
          : file.dataItem?.casePrepExportStatus;
    } else {
      this.fileName = file.fileName;
      this.fileSize = file.fileSize;
      this.lastModifiedDate = file.lastModifiedDate;
      this.uploadedDate = file.uploadedDate;
      this.details = file.details;
      this.locked = file.locked;
      this.uid = file.uid;
      this.id = file.id;
      this.labels = file.labels;
      this.uploadedBy = file.uploadedBy;
      this.uri = file.uri;
      this.path = file.path;
      this.attachmentType = file.attachmentType;
      this.summary = file.summary;
      this.isDirectory = file.isDirectory || false;
      this.casePrepExportStatus = file.casePrepExportStatus || 0;
    }
  }
}
